import { render, staticRenderFns } from "./quotationPrePortDetail.vue?vue&type=template&id=4bd39baf&scoped=true&"
import script from "./quotationPrePortDetail.vue?vue&type=script&lang=js&"
export * from "./quotationPrePortDetail.vue?vue&type=script&lang=js&"
import style0 from "./quotationPrePortDetail.vue?vue&type=style&index=0&id=4bd39baf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd39baf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd39baf')) {
      api.createRecord('4bd39baf', component.options)
    } else {
      api.reload('4bd39baf', component.options)
    }
    module.hot.accept("./quotationPrePortDetail.vue?vue&type=template&id=4bd39baf&scoped=true&", function () {
      api.rerender('4bd39baf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Quotation/quotationPrePortDetail.vue"
export default component.exports